import { useEffect, useState } from 'react'
import { Connection } from '@integration-app/sdk'
import { TbSettings } from 'react-icons/tb'

import { IconButton } from 'components/Button/IconButton'
import { IntegrationComboboxSelect } from 'components/IntegrationElements/ComboboxSelects/IntegrationComboboxSelect'
import { useWorkspace } from 'components/Workspaces/workspace-context'
import { useNavigateRouterTo } from 'hooks/useNavigateRouterTo'
import { Flex } from 'styled-system/jsx'
import { Button } from 'ui-kit/button'

export function IntegrationWithConnectionComboboxSelect({
  name,
  integrationKey,
  onIntegrationSelect,
}: {
  name?: string
  integrationKey: string
  onIntegrationSelect?: (integrationKey: string | undefined) => void
}) {
  const navigateToConnection = useNavigateRouterTo('connection')
  const { testCustomerClient } = useWorkspace()
  // FIXME: strictNullCheck temporary fix
  // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
  const [connection, setConnection] = useState<Connection>(null)
  const [loadingConnection, setLoadingConnection] = useState(false)

  function handleOpenConnectionSidePanel() {
    if (!connection) return

    return navigateToConnection(connection)
  }

  useEffect(() => {
    if (integrationKey && testCustomerClient) {
      // FIXME: strictNullCheck temporary fix
      // @ts-expect-error TS(2345): Argument of type 'null' is not assignable to param... Remove this comment to see the full error message
      setConnection(null)
      void loadConnection()
    }
  }, [integrationKey, testCustomerClient])

  async function handleConnect() {
    if (!integrationKey) return

    const newConnection = await testCustomerClient
      .integration(integrationKey)
      .openNewConnection()

    setConnection(newConnection)
  }

  async function loadConnection() {
    if (!integrationKey) return

    setLoadingConnection(true)

    const data = await testCustomerClient.get('connections', {
      integrationKey: integrationKey,
    })

    if (data?.items?.length) setConnection(data.items[0])

    setLoadingConnection(false)
  }

  return (
    <Flex gap={2}>
      <IntegrationComboboxSelect
        width={56}
        size={'md'}
        name={name}
        value={integrationKey}
        onChange={(integration) => onIntegrationSelect?.(integration)}
      />

      {!connection && (
        <Button
          size={'md'}
          onClick={handleConnect}
          disabled={loadingConnection || !integrationKey}
        >
          Connect
        </Button>
      )}

      {connection && (
        <IconButton
          tooltip='Congifure'
          variant='outline'
          onClick={handleOpenConnectionSidePanel}
        >
          <TbSettings />
        </IconButton>
      )}
    </Flex>
  )
}
